import React, {
    useState,
    FormEvent,
} from 'react';

import { 
    IonContent, 
    IonHeader, 
    IonPage, 
    IonTitle, 
    IonFooter,
    IonToolbar,
    IonButton,
    IonGrid,
    IonRow,
    IonCol,
    IonItem,
    IonLabel,
    IonInput,
    useIonRouter,
    NavContext,
    IonText,
    IonImg,
    IonNavLink,
    IonAvatar,
    IonChip,
    IonCard,
    IonCardContent,
    IonPopover,
    IonList,
    IonIcon,
    IonSpinner,
    useIonViewWillEnter,
    IonItemOptions,
    IonItemOption,
    IonItemSliding,
    IonSearchbar,
    IonBackdrop,
    IonCheckbox,
    IonRouterLink
} from '@ionic/react';

import {
  SignInWithApple,
  SignInWithAppleResponse,
  SignInWithAppleOptions,
} from '@capacitor-community/apple-sign-in';

import { GoogleAuth } from '@codetrix-studio/capacitor-google-auth';
import { Plugins, Capacitor } from '@capacitor/core';
import { ellipsisVertical, close, mail, logoGoogle, logoApple, createOutline } from "ionicons/icons";

import { hideTab } from "../components/Tabs";
import NServer from "../components/NServer";
import Vault from '../components/Vault';
import { isPlatform, getPlatforms  } from '@ionic/react';
import { UserInfo } from "../data/user";
import { showAlert } from '../components/Alert';
import { Browser } from '@capacitor/browser';

import { LANGUAGE, GetStr, LoadLanguage, SaveLanguage, GetLanguage } from "../language/Language";

import './Main.css';

type FormErrors = {
    email : string;
    password : string;
};

type LoginData = {
    email : string,
    password : string
    name : string,
    avatar : string,
    gauth : string,
    lang : string,
    formErrors : FormErrors,
    emailValid : boolean,
    passwordValid : boolean,
    formValid : boolean
};


const Login : React.FC = () => {

    const [email, setEmail] = useState("");
    const [name, setName] = useState("");
    const [password, setPassword] = useState("");
    const [avatar, setAvatar] = useState("");
    const [gauth, setGAuth] = useState("");
    const [loginValid, setLoginValid] = useState(false);
    const [view, setView] = useState("loading");
    const router = useIonRouter();

    const [emailLogin, setEmailLogin] = useState(false);
    const [googleLogin, setGoogleLogin] = useState(false);
    const [appleLogin, setAppleLogin] = useState(false);
    const [slogan, setSlogan] = useState("");
    const [userList, setUserList] = useState<UserInfo[]>([]);
    const [tos, agreedTOS] = useState(true);

    useIonViewWillEnter(() => {
        hideTab();

        // use hook after platform dom ready
        GoogleAuth.initialize({
            clientId: '539449161874-6ocs4f93aioho9d8g7nbij18p471h33d.apps.googleusercontent.com',
            scopes: ['profile', 'email'],
            grantOfflineAccess: true,
        });

        loadApp();

        if (Capacitor.isNative) {
            Plugins.App.addListener("backButton", () => {
                if (window.location.pathname == '/login')
                    Plugins.App.exitApp();
            });
        }

        console.log(IonBackdrop);
    });

    // load the app
    const loadApp = async () => {
        let platform = "unknown";
        if (isPlatform("desktop"))
            platform = "desktop";
        if (isPlatform("android"))
            platform = "android";
        if (isPlatform("ios"))
            platform = "ios";

        let platform_ids = getPlatforms();

        let v = new Vault();
        await v.read();

        const state = {
            platform : platform,
            platform_ids: platform_ids,
            lang: GetLanguage(),
            accounts: v.savedAccounts
        }

        var server = new NServer();
        await server.getList("nc_init_app", state);
        
        if (!server.success && server.message != "")
        {
            showAlert(server.message);

            if (server.data != null)
            {
                if (server.data.hasOwnProperty('path'))
                {
                    let err_path = server.data.path;
                    if (err_path == "update")
                        router.push("/update", "back", "pop");
                    if (err_path == "mantain")
                        router.push("/mantain", "back", "pop");
                }
            }
        }
        else
        {
            setEmailLogin(server.data.email == "yes");
            setGoogleLogin(server.data.google == "yes");
            setAppleLogin(server.data.apple == "yes");
            setSlogan(server.data.slogan);
            setUserList(server.data.accounts);

            setView("");
        }
    }

    // switch languages
    const switchLang = async (lang : string) => {
        setView("loading");

        await SaveLanguage(lang);

        await loadApp();
    }

    const GoogleSignup = async () => {

        const googleUser = await GoogleAuth.signIn();
        //DEL console.log(JSON.stringify(googleUser));
        
        const state = {
            email : googleUser.email,
            password : "",
            name : googleUser.givenName + " " + googleUser.familyName,
            avatar : googleUser.imageUrl,
            gauth : googleUser.id,
            lang: GetLanguage()
        }

        var server = new NServer();
        await server.sendForm("login_gauth", state);
        
        if (!server.success && server.message != "")
            showAlert(server.message);
        else
        {
            // move to confirm page
            var path =  server.data.path;

            // save to vault
            let v = new Vault();
            await v.read();

            v.account.id = server.data.id;
            v.account.key = server.data.key;
            v.saveCurAccount();

            await v.write();

            loginSuccess();
        }
    }

    // Apple sign up
    const AppleSignup = async () => {
        let options: SignInWithAppleOptions = {
            clientId: 'com.nwallet.social',
            redirectURI: 'https://nwallet.me/d/app_login.php',
            scopes: 'email name',
            state: '12345',
            nonce: 'nonce',
        };

        SignInWithApple.authorize(options)
            .then((result: SignInWithAppleResponse) => {
                // Handle user information
                // Validate token with server and create new session
            })
            .catch(error => {
                // Handle error
            });
    }

    //	go to register page
    const onRegister = () => {
        router.push("/register", "forward", "push");
    }

    //	go to forget password page
    const onForgetPassword = () => {
        router.push("/forgetpassword", "forward", "push");
    }

    //	go to passkey page
    const onSetPasskey = () => {
        router.push("/home", "back", "pop");
    }

    // log into email
    const doEmailLogin = () => {
        setView("email");
    }
    
    // back to main view
    const backView = () => {
        setView("");
    }

    // change email
    const changeEmail = ( e : any ) : void => {
        let inputEmail = "";
        if (e.detail.value != null)
            inputEmail = e.detail.value.toString();

        setEmail(inputEmail);

        // check for login valid
        let emailValid = inputEmail.match(/^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i) != null;
        let passwordValid = password.length >= 6;
        setLoginValid(emailValid && passwordValid);
    }

    // change email
    const changePassword = ( e : any ) : void => {
        let inputPassword = "";
        if (e.detail.value != null)
            inputPassword = e.detail.value.toString();

        setPassword(inputPassword);

        // check for login valid
        let emailValid = email.match(/^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i) != null;
        let passwordValid = inputPassword.length >= 6;
        setLoginValid(emailValid && passwordValid);
    }

    // when form submit
    const submit = async () => {

        setLoginValid(false);
        
        const state = {
            email : email,
            password : password,
            name : name,
            avatar : avatar,
            gauth : gauth,
            lang: GetLanguage()
        }

        var server = new NServer();
        await server.sendForm("nc_login", state);
        
        setLoginValid(true);

        if (!server.success && server.message != "")
            showAlert(server.message);
        else
        {
            // move to confirm page
            var id = server.data.id;
            var key = server.data.key;
            var path =  server.data.path;

            if (path == 'confirm')
            {
                loginConfirmEmail();
            }
            if (path == 'lock')
            {
                loginLocked();
            }
            else
            {
                // save to vault
                let v = new Vault();
                await v.read();

                v.account.id = server.data.id;
                v.account.key = server.data.key;
                v.saveCurAccount();

                await v.write();

                if (path == "passkey")
                    onSetPasskey();
                if (path == "main")
                    loginSuccess();
            }
        }
    }

    // login success
    const loginSuccess = () => {
        router.push("/loader", "back", "pop");
    }

    // login confirm email
    const loginConfirmEmail = () => {
        router.push("/confirm_email", "forward", "push");
    }

    // login confirm email
    const loginLocked = () => {
        router.push("/account_lock", "back", "pop");
    }

    // do the saved login
    const doSavedLogin = async(id : number) => {
        let v = new Vault();
        await v.read();

        if (v.loginSavedAccount(id))
        {
            await v.write();
            // straight to main
            router.push("/loader", "back", "pop");
        }
    }

    // delete the account
    const deleteAccount = async(id : number) => {
        let v = new Vault();
        await v.read();

        v.deleteSavedAccount(id);

        await v.write();

        loadApp();
    }

    // view terms & conditions
    const onTOS = () => {
        Browser.open({ url: "https://nwallet.me/d/tos.php?lang="+GetLanguage() });
    }

    return (
        <IonPage className="login-page">
            <IonContent>
                <IonHeader collapse="condense">
                </IonHeader>
                <IonGrid className="ion-no-padding">
                    <IonRow>
                        <IonCol className="ion-padding">
                            <IonChip id="lang-but" className="ion-float-right" color="light">Languages</IonChip>
                            <IonPopover trigger="lang-but" reference="event" dismissOnSelect={true}>
                                <IonContent>
                                    <IonList>
                                        <IonItem button={true} detail={false} lines="none" onClick={ ()=> {switchLang("en")} }>
                                            <IonImg slot="start" src="assets/img/flag_us.jpg"></IonImg>
                                            <IonLabel>{ GetStr(LANGUAGE.TXT_ENGLISH_LANGUAGE) }</IonLabel>
                                        </IonItem>
                                        <IonItem button={true} detail={false} lines="none" onClick={ ()=> {switchLang("mmun")} }>
                                            <IonImg slot="start" src="assets/img/flag_mm.jpg"></IonImg>
                                            <IonLabel>{ GetStr(LANGUAGE.TXT_MMUN_LANGUAGE) }</IonLabel>
                                        </IonItem>
                                        <IonItem button={true} detail={false} lines="none" onClick={ ()=> {switchLang("mand")} }>
                                            <IonImg slot="start" src="assets/img/flag_mand.jpg"></IonImg>
                                            <IonLabel>{ GetStr(LANGUAGE.TXT_MANDARIN_LBL) }</IonLabel>
                                        </IonItem>
                                        { /* 
                                        <IonItem button={true} detail={false} lines="none" onClick={ ()=> {switchLang("kch")} }>
                                            <IonImg slot="start" src="assets/img/flag_kch.jpg"></IonImg>
                                            <IonLabel>{ GetStr(LANGUAGE.TXT_KACHIN_LANGUAGE) }</IonLabel>
                                        </IonItem>
                                        <IonItem button={true} detail={false} lines="none" onClick={ ()=> {switchLang("sha")} }>
                                            <IonImg slot="start" src="assets/img/flag_sha.jpg"></IonImg>
                                            <IonLabel>{ GetStr(LANGUAGE.TXT_SHAN_LANGUAGE) }</IonLabel>
                                        </IonItem>
                                        <IonItem button={true} detail={false} lines="none" onClick={ ()=> {switchLang("chin")} }>
                                            <IonImg slot="start" src="assets/img/flag_chin.jpg"></IonImg>
                                            <IonLabel>{ GetStr(LANGUAGE.TXT_CHIN_LANGUAGE) }</IonLabel>
                                        </IonItem>
                                        
                                        */ }
                                    </IonList>
                                </IonContent>
                            </IonPopover>
                        </IonCol>
                    </IonRow>
                    <IonRow>
                        <IonCol>
                        </IonCol>
                        <IonCol size-lg="1" size-md="2" size="5">
                            <IonImg className="ion-margin-bottom" src="/assets/img/big_logo.png" />
                        </IonCol>
                        <IonCol>
                        </IonCol>
                    </IonRow> 
                    <IonRow>
                        <IonCol>
                        </IonCol>
                        <IonCol size-lg="4" size-md="6" size="12">
                            {
                                slogan != "" && userList.length <= 0 ?
                            <IonImg src={slogan} />
                                :
                            <div className="login-box">
                            {
                                userList.map( m => 
                                <IonCard className="ion-margin-start ion-margin-end card-flat-white" key={m.id}>
                                        <IonItemSliding>
                                            <IonItem lines="none" onClick={()=> { doSavedLogin(m.id) } }>
                                                <IonAvatar slot="start">
                                                    <img src={m.avatar} onError={ ({currentTarget}) => { currentTarget.src = 'assets/img/avt.jpg' } } />
                                                </IonAvatar>
                                                <IonLabel>{ m.displayName }</IonLabel>
                                            </IonItem>

                                            <IonItemOptions  side="end">
                                                <IonItemOption color="danger" onClick={() => deleteAccount(m.id) }>{ GetStr(LANGUAGE.TXT_DELETE) }</IonItemOption>
                                            </IonItemOptions>
                                        </IonItemSliding>
                                    </IonCard>
                                )
                            } 
                                {
                                    userList.length > 0 ?
                                <div className="ion-text-center ion-margin-bottom"><IonText color="light"><small>{ GetStr(LANGUAGE.TXT_SLIDE_LEFT_DEL) }</small></IonText></div>
                                    :
                                <div/>
                                }
                            </div>
                            }
                        </IonCol>
                        <IonCol>
                        </IonCol>
                    </IonRow> 
                    {
                        view == "loading" ?
                    <IonRow>
                        <IonCol>
                        </IonCol>
                        <IonCol className="ion-margin" size-md="2" size="5">
                            <div className="spinnerLogin">
                                <IonSpinner name="crescent" />
                            </div>
                        </IonCol>
                        <IonCol>
                        </IonCol>
                    </IonRow> 
                        :
                    <div/>
                    }
                </IonGrid>
            </IonContent>
            <IonFooter className="footer">
                <IonGrid className="ion-no-padding">
                    <IonRow className="ion-margin-top ion-margin-bottom">
                        <IonCol>
                        </IonCol>
                        <IonCol className="ion-justify-content-end" size-lg="4" size-md="6" size="12">
                            {
                                view == "" ?
                            <div className="ion-padding-start ion-padding-end">
                                {
                                    googleLogin ?
                                <IonButton className="main-but ion-margin-top" color="primary" expand="block" onClick={GoogleSignup} disabled={!tos}>
                                    <IonIcon icon={logoGoogle} />&nbsp;&nbsp;
                                    { GetStr(LANGUAGE.TXT_GOOGLE_LOGIN) }
                                </IonButton>
                                    :
                                <div/>
                                }

                                {
                                    appleLogin ?
                                <IonButton className="main-but ion-margin-top" color="primary" expand="block" onClick={AppleSignup}>
                                    <IonIcon icon={logoApple} />&nbsp;&nbsp;
                                    { GetStr(LANGUAGE.TXT_SIGNIN_WITH_APPLE) }
                                </IonButton>
                                    :
                                <div/>
                                }

                                {
                                    emailLogin ?
                                <IonButton className="main-but ion-margin-top" color="secondary" expand="block" onClick={doEmailLogin} disabled={!tos}>
                                    <IonIcon icon={mail} />&nbsp;&nbsp;
                                    { GetStr(LANGUAGE.TXT_LOGIN_WITH_EMAIL) }
                                </IonButton>
                                    :
                                <div/>
                                }
                                <IonItem color="clear" lines="none" text-wrap>
                                    <IonCheckbox slot="start" checked={tos} onIonChange={ () => agreedTOS(!tos) }></IonCheckbox>
                                    <IonLabel className="ion-text-wrap">
                                        I agree to the terms and conditions
                                        <IonButton color="primary" onClick={ onTOS } fill="clear"><b>View Terms & Conditions</b></IonButton>
                                    </IonLabel><br/>
                                </IonItem>
                            </div>
                                :
                                ( view == "email" ?
                            <IonCard className="flat-card bk">
                                <IonCardContent>
                                    <div className="ion-text-right">
                                        <IonButton fill="clear" onClick={backView}><IonIcon icon={close} />&nbsp;</IonButton>
                                    </div>
                                    <IonItem color="none">
                                        <IonLabel position="floating"><IonText color="white">{ GetStr(LANGUAGE.TXT_EMAIL) }</IonText></IonLabel>
                                        <IonInput name="email" onIonChange={changeEmail} />
                                    </IonItem>
                                    <IonItem color="none">
                                        <IonLabel position="floating">{ GetStr(LANGUAGE.TXT_PASSWORD) }</IonLabel>
                                        <IonInput type="password" name="password" onIonChange={changePassword} />
                                    </IonItem>
                                    <IonButton className="ion-margin-top" size="small" fill="clear" onClick={onForgetPassword} >
                                        { GetStr(LANGUAGE.TXT_FORGET_PASSWORD) }
                                    </IonButton>
                                    <IonButton className="main-but ion-margin-top" color="primary" expand="block" onClick={submit} disabled={!loginValid}>
                                        { GetStr(LANGUAGE.TXT_DO_LOGIN) }
                                    </IonButton>
                                    <IonButton className="main-but ion-margin-top" expand="block" onClick={onRegister}>
                                        <IonIcon icon={createOutline} />&nbsp;
                                        { GetStr(LANGUAGE.TXT_DO_REGISTER) }
                                    </IonButton>
                                </IonCardContent>
                            </IonCard>
                                :
                            <div/>
                                )
                            }
                        </IonCol>
                        <IonCol>
                        </IonCol>
                    </IonRow> 
                </IonGrid>
            </IonFooter>
        </IonPage>
    );
};


export default Login;